module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Picnic-At-Hanging-Rock-S1.e5f4787.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Picnic-At-Hanging-Rock-S1.jpg
// module id = 8aAI
// module chunks = 0